/* BPO */
import { FEATURES } from '@constants/Text'
import * as calendarStore from './store'

export function calendarModule({ store }) {
  store.registerModule('calendar', {
    ...calendarStore,
    namespaced: true,
  })
}

export const PERMISSION = FEATURES.TASKS
